import { Component, OnInit, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OldDataService } from 'src/app/core/services/old-data.service';
import Swal from 'sweetalert2';
import { User } from '../../../core/models/user';
import { getFirebaseBackend } from 'src/app/authUtils';
import { TIMEZONES } from '../../timezones';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { UserService } from 'src/app/services/user/user.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { RingcentralService } from 'src/app/services/ringcentral/ringcentral.service';

@Component({
	selector: 'user-edit',
	templateUrl: './user-edit.component.html',
	styleUrls: ['./user-edit.component.scss'],
})
export class UserEditComponent implements OnInit {
	public user: User;
	public userProfileId: number;
	public today: Date = new Date();

	public userProfile: any = null;
	public userProfileMsg: string;
	public userProfileLoading: boolean = true;

	public campaigns: any = [];
	public assignedCampaigns: any = [];
	public unassignedCampaigns: any = [];
	public campaignsMsg: string;
	public campaignsLoading: boolean = true;

	public activeTab: any = 'user_information';
	public campaignsTab: string = 'assigned';

	public dispoLog: any = null;
	public dispoLogLoading: boolean = false;
	public dispoSearchMonth: number;
	public dispoSearchDay: number;
	public dispoSearchYear: number;

	public options: any[];
	public timezones: any[];
	dialLoading: any;
	isAdmin: number;
	IsActive: any;
	first: any;
	last: any;
	email1: any;
	ringcentral_ext: any;
	rc_ext_id: any;
	timezone: any;
	IsClient: any;

	constructor(
		private router: Router,
		private dataService: OldDataService,
		private route: ActivatedRoute,
		public authenticationService: AuthenticationService,
		public userSrv: UserService,
		public utils: UtilsService,
		public ringcentralSrv: RingcentralService
	) {
		this.options = [
			{
				text: 'User information',
				tab_name: 'user_information',
				icon: 'fa fa-user',
			},
			{
				text: 'Assign Campaigns',
				tab_name: 'campaign_allocation',
				icon: 'fa fa-database',
			},
			{
				text: 'Dispo Log',
				tab_name: 'log',
				icon: 'fa fa-book',
			},
			{
				text: 'Stats',
				tab_name: 'stats',
				icon: 'fa fa-bar-chart',
			},
			{
				text: 'Active Modules',
				tab_name: 'activeModules',
				icon: 'fa fa-bar-chart',
			},
		];

		this.timezones = TIMEZONES;
		// this.user = this.authenticationService.currentUserValue;
		this.user = getFirebaseBackend()?.getAuthenticatedUser();
		this.userSrv.getUserById(this.user.IdUser).subscribe((data: any) => {
				const user = data.body;
					this.isAdmin = user.isAdmin;
					if (this.isAdmin == 1) {
						if (this.route.snapshot.queryParams['id']) {
							this.userProfileId =+ this.route.snapshot.queryParams['id'];
							this.getUserProfileById();
							this.getCampaigns();

							let d = new Date();
							let month = d.getMonth() + 1;
							let day = new Date().getDate();
							let year = d.getFullYear();

							this.dispoSearchMonth = this.pad(month, 2, 0);
							this.dispoSearchDay = this.pad(day, 2, 0);
							this.dispoSearchYear = year;
						}
					} else {
						this.router.navigate(['/employee-users']);
					}
			});
	}

	ngOnInit() {}

	pad(n: any, width: any, z: any) {
		z = z || '0';
		n = n + '';
		return n.length >= width
			? n
			: new Array(width - n.length + 1).join(z) + n;
	}

	goToAdmin() {
		this.router.navigate(['/admin-portal']);
	}

	getUserProfileById() {
		this.userProfileId
		this.userSrv.getUserById(this.userProfileId).subscribe((data: any) => {
			const user = data.body;

			this.userProfile = user;
			this.IsActive = user.isActive;
			this.first = user.first;
			this.last = user.last;
			this.email1 = user.email1;
			this.ringcentral_ext = user.ringcentral_ext;
			this.rc_ext_id = user.rc_ext_id;
			this.timezone = user.timezone;
			this.IsClient = user.isClient;

			this.userProfileLoading = false;
		});
	}

	getCampaigns() {
		this.campaignsLoading = true;
		this.campaigns = [];
		this.assignedCampaigns = [];
		this.unassignedCampaigns = [];

		this.userSrv.getUserAssignedCampaigns(this.userProfileId).subscribe((data: any) =>{
			for (let campaign of data.body) {
				if (campaign.isAssigned == 1) {
					this.assignedCampaigns.push(campaign);
				} else if (campaign.isAssigned == 0) {
					this.unassignedCampaigns.push(campaign);
				}
			}

			this.campaignsLoading = false;
			this.toggleCampaignList('assigned');
		});
	}

	toggleCampaignList(type: string) {
		this.campaigns = null;

		if (type === 'assigned') {
			this.campaigns = this.assignedCampaigns;
			this.campaignsTab = type;
		} else if (type === 'unassigned') {
			this.campaigns = this.unassignedCampaigns;
			this.campaignsTab = type;
		}
	}

	assignCampaignConfirm(campaign: any) {
		Swal.fire({
			title:
				'Assign ' +
				campaign.name +
				' to ' +
				this.userProfile.first +
				' ' +
				this.userProfile.last +
				'?',
			text: 'ARE YOU SURE?',
			showCancelButton: true,
			confirmButtonText: 'Yes',
			cancelButtonText: 'Cancel',
		}).then((result) => {
			if (result.value) {
				this.assignCampaignToUser(campaign);
			}
		});
	}

	assignCampaignToUser(campaign: any) {
		this.campaignsLoading = true;
		const payload = {
			user: this.userProfileId,
			campaign: campaign.id,
		};
		this.userSrv.assignCampaignToUser(payload).subscribe((data: any)=>{
			this.getCampaigns();
		});
	}

	removeCampaignConfirm(campaign: any) {
		Swal.fire({
			title:
				'Remove ' +
				campaign.name +
				' from ' +
				this.userProfile.first +
				' ' +
				this.userProfile.last +
				'?',
			text: 'ARE YOU SURE?',
			showCancelButton: true,
			confirmButtonText: 'Yes',
			cancelButtonText: 'Cancel',
		}).then((result) => {
			if (result.value) {
				this.removeCampaignFromUser(campaign);
			}
		});
	}

	removeCampaignFromUser(campaign: any) {
		this.campaignsLoading = true;
		const payload = {
			user: this.userProfileId,
			campaign: campaign.id,
		}

		this.userSrv.removeCampaignFromUser(payload).subscribe((data: any)=>{
			this.getCampaigns();
		});
	}

	removeAllCampaignsConfirm() {
		if (this.campaigns && this.campaigns.length) {
			Swal.fire({
				title:
					'Remove all campaigns from ' +
					this.userProfile.first +
					' ' +
					this.userProfile.last +
					'?',
				text: 'ARE YOU SURE?',

				showCancelButton: true,
				confirmButtonText: 'Yes',
				cancelButtonText: 'Cancel',
			}).then((result) => {
				if (result.value) {
					this.removeAllCampaignsFromUser();
				}
			});
		} else {
			Swal.fire('No assigned campaigns to remove.');
		}
	}

	removeAllCampaignsFromUser() {
		this.campaignsLoading = true;
		const payload =  { user: this.userProfileId }

		this.userSrv.removeAllCampaignsFromUser(payload).subscribe((data: any)=>{
			this.getCampaigns();
		});
	}

	assignAllCampaignsConfirm() {
		if (this.campaigns && this.campaigns.length) {
			Swal.fire({
				title:
					'Assign all campaigns to ' +
					this.userProfile.first +
					' ' +
					this.userProfile.last +
					'?',
				text: 'ARE YOU SURE?',

				showCancelButton: true,
				confirmButtonText: 'Yes',
				cancelButtonText: 'Cancel',
			}).then((result) => {
				if (result.value) {
					this.assignAllCampaignsToUser();
				}
			});
		} else {
			Swal.fire('All campaigns are assigned already.');
		}
	}

	assignAllCampaignsToUser() {
		this.campaignsLoading = true;
		const campaignsArr = [];

		for (let campaign of this.campaigns) {
			campaignsArr.push(campaign.id);
		}

		const payload = { user: this.userProfileId, campaigns: campaignsArr }

		this.userSrv.assignAllCampaignsToUser(payload).subscribe((data: any)=>{
			this.getCampaigns();
		});
	}

	getUserDispoLogByDate() {
		this.dispoLog = [];

		if ( this.dispoSearchYear && this.dispoSearchMonth && this.dispoSearchDay ) {
			this.dispoLogLoading = true;

			const date = `${this.dispoSearchYear}-${this.dispoSearchMonth}-${this.dispoSearchDay}`;


				const payload = { user: this.userProfileId, searchDate: date }
				this.userSrv.getUserdisposByData(payload).subscribe((data: any)=>{
					this.dispoLog = data.body;
					this.dispoLogLoading = false;
				})
		}
	}

	dialProspect(campaign: any, prospect: any) {
		this.router.navigate(['/caller/lead-profile'], {
			queryParams: { campaign, prospect },
		});
	}

	goToEmployeeUsers() {
		this.router.navigate(['/admin-portal/app-employee-users'], {
			queryParams: { toView: 'employeeModule' },
		});
	}

	saveUserInfo() {
		if (this.email1 !== '' && this.email1 !== null) {

			const payload = { email: this.email1 }
			this.ringcentralSrv.getUserExtension(payload).subscribe((data: any)=>{
				this.ringcentral_ext = data.body[0].extensionNumber;
				this.rc_ext_id = data.body[0].id;
				const payload2 = { user: this.userProfile };
				this.userSrv.updateData(payload2).subscribe((data: any)=>{
					this.utils.swal(
						'Updated',
						'success',
						'User updated',
					);
				});
			});

		} else {
			this.utils.swal(
				'Error',
				'error',
				'The email is mandatory to get the extension ID',
			);
		}
	}
}
